import { CmblAddress } from './cmbl-address.model';
import { Latng } from './latng';

export class Address {

  public latitude: number;
  public longitude: number;
  public formatted: string;
  public address: string;
  public city: string;
  public state: string;
  public zip: string;
  public country: string;
  public countryCode: string;

  public static fromCmblAddress(cmblAddress: CmblAddress, latng: Latng): Address {
    if (!cmblAddress) {
      return null;
    }

    const address = new Address();

    address.address = cmblAddress.address1;
    address.city = cmblAddress.city;
    address.zip = cmblAddress.zip;
    address.state = cmblAddress.state;
    address.country = cmblAddress.countryName;
    address.countryCode = cmblAddress.country;

    if (latng) {
      address.latitude = latng.latitude;
      address.longitude = latng.longitude;
    }

    let formatted: string[] = [address.address, `${address.zip} ${address.city}`, address.state, address.country]
      .filter(l => !!l)
      .map(l => l.trim());

    address.formatted = formatted.join(', ');

    return address;
  }

}
